import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { HttpCommonService, LookupService, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";

import { SelectorService } from "../base/selector.service";
import { DropdownPosition } from "../ng-select/ng-select.component";

import { MonthsNameService } from "projects/sepidz-web-framework/src/lib/services/monthe-name.service";
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

@Component({
  selector: "ssg-select",
  templateUrl: "selector.component.html",
  styleUrls: ["selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectorComponent extends BaseControlComponent<any> {
  isshow: boolean;
  isfocus: boolean = false;
  canOpen: boolean = false;
  mainMultiDataKey: string[] = [];
  firstDatakey: string;
  multiDataKey: string[] = [];
  multiDataKeyTitle: string[] = [];
  totalPage: number;
  MultiColumnsFilter: string;
  @Input() SortColumn: string;
  @Input() IsEqual: boolean;
  startSearch: boolean;
  public formGroup: FormGroup;
  paginationEnum: typeof PaginationEnum = PaginationEnum;
  _filterdItems: any[] = [];

  @Input() hasDefault: boolean;
  @Input() clearable: boolean = true;
  @Input() clearOnBackspace: boolean = true;
  @Input() searchable: boolean = true;
  @Input() selectOnTab: boolean = true;
  @Input() dropdownPosition: DropdownPosition = "auto";
  @Output() valueClear = new EventEmitter<any>();
  @Output() CompleteData = new EventEmitter<any>();
  @Output() addItem = new EventEmitter<any>();
  @Output() removeItem = new EventEmitter<any>();
  @Input() apiName: string;
  @Input() icon: string;
  @Input() size: string;
  @Input() systemName: string;
  @Input() category: string;
  @Input() valueFieldName: string;
  @Input() textFieldName: string;
  @Input() closeOnSelect: boolean = true;
  @Input() isMultiColumns: boolean = false;
  mainDataList: PagingDataResult<any>;
  // @Input() appendTo: string;
  /// محدود سازی انتخاب ها
  @Input() limitSelection: number;
  // لیست غیرفعال ها
  @Input() disabledList: any[] = [];
  // اضافه کردن حالت انتخابی
  @Input() hasCheckBox: boolean = false;
  // اضافه کردن خاصیت انتخاب کل
  @Input() hasSelectAll: boolean;

  _paretnIdValue: number;
  _parentIdName: string;
  _dataList: any[];
  @Input() set dataList(value: any[]) {
    this._dataList = value;
    this.setItems();
  }
  get dataList(): any[] {
    return this._dataList;
  }
  @Input() repeatable: boolean;
  @Input() readonly: boolean;

  @Input()
  get paretnIdValue(): number {
    return this._paretnIdValue;
  }
  set paretnIdValue(value: number) {
    this._paretnIdValue = value ?? this.selectorService.getParetnIdValue(this.parentIdName);
    if (this.dataList && this.selectorService.getParetnIdValue(this.parentIdName))
      this._filterdItems = this.dataList?.filter((x) => x[this.parentIdName] === this.selectorService.getParetnIdValue(this.parentIdName));
    else if (this.dataList && this._paretnIdValue) this._filterdItems = this.dataList?.filter((x) => x[this.parentIdName] === this._paretnIdValue);
    this.cd.markForCheck();
  }
  @Input()
  get parentIdName(): string {
    return this._parentIdName;
  }
  set parentIdName(value: string) {
    this._parentIdName = value;
  }
  loading = false;
  @Input() filterKey: string;
  _filterValue: any;
  @Input()
  get filterValue(): any {
    return this._filterValue;
  }
  set filterValue(value: any) {
    this._filterValue = value;
  }

  constructor(
    private _httpCommonService: HttpCommonService,
    private lookupservice: LookupService,
    protected cd: ChangeDetectorRef,
    protected selectorService: SelectorService,
    private monthsnameService: MonthsNameService
  ) {
    super(selectorService, cd);
    this.isshow = false;
  }

  ngAfterViewChecked(): void {
    super.ngAfterViewChecked();
    this.testHasValue();
  }

  ngAfterViewInit(): void {
    if (this.group?.controls && this.name) {
      this.group?.controls[this.name]?.valueChanges?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => this.cd.markForCheck());
    }
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.isMultiColumns) {
      this.setValue("PaginationNumber", 1);
    }
    this.isshow = false;
    this.setDisabledValue();
    this.selectorService.onDataListChanged.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      this.setItems();
    });
    this.selectorService.onParetnIdValueChanged.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && this.parentIdName) {
        this.paretnIdValue = this.selectorService.getParetnIdValue(this.parentIdName);
      }
    });
    if (this.apiName && this.apiName.includes("MonthsName")) {
      this.dataList = this.monthsnameService.MonthList;
      this.setItems();
    } else if (
      (!this.dataList ||
        this.dataList?.length <= 0 ||
        !this.selectorService.getDataList(this.name)) &&
      this.apiName
    ) {
      if (this.apiName) {
        this.loading = true;
        if (!this.systemName && !this.category) {
          if (!this.isMultiColumns) {
            this._httpCommonService
              .getList(this.apiName)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (data: any) => {
                  if (this.isMultiColumns && data) {
                    this.dataList = (data as any)?.Data;
                    this.totalPage = Math.trunc(data?.TotalPage / 4) + ((data?.TotalPage / 4) % 1 > 0 ? 1 : 0);
                    if (this.totalPage <= 0) this.totalPage = 1;
                    this.mainMultiDataKey = this.textColumnsName.split(",");
                    this.multiDataKeyTitle = this.columnsTitleName.split(",");
                    this.firstDatakey = this.mainMultiDataKey[0];
                    this.multiDataKey = this.mainMultiDataKey.splice(1, this.mainMultiDataKey?.length);
                  } else {
                    this.dataList = data as [];
                  }
                  this.loading = false;
                  this.setDefault();
                  this.setItems();
                  this.cd.markForCheck();
                  this.CompleteData.emit({ apiName: this.apiName, data: data });
                },
                (error) => this.getFailedHelper(error)
              );
          } else {
            this.paginationData();
          }
        } else
          this.lookupservice
            .getLookupbyCategory(this.systemName, this.category)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
              this.dataList = data as [];
              this.loading = false;
              this.setDefault();
              this.setItems();
              this.CompleteData.emit(data);
              this.cd.markForCheck();
            });
      }
    }
  }
  paginationData() {
    this._httpCommonService
      .GetPagining(this.apiName, "", "", 0, 4, this.SortColumn, this.IsEqual)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          if (this.isMultiColumns && data) {
            this.dataList = (data as any)?.Data;
            this.totalPage = Math.trunc(data?.TotalPage / 4) + ((data?.TotalPage / 4) % 1 > 0 ? 1 : 0);
            if (this.totalPage <= 0) this.totalPage = 1;
            this.mainMultiDataKey = this.textColumnsName.split(",");
            this.firstDatakey = this.mainMultiDataKey[0];
            this.multiDataKeyTitle = this.columnsTitleName.split(",");
            this.multiDataKey = this.mainMultiDataKey.splice(1, this.mainMultiDataKey?.length);
          } else {
            this.dataList = data as [];
          }
          this.loading = false;
          this.setDefault();
          this.setItems();
          this.cd.markForCheck();
          this.CompleteData.emit({ apiName: this.apiName, data: data });
          this.getDataValueWhenValueIsNotExistInDataList();
        },
        (error) => this.getFailedHelper(error)
      );
  }

  setDisabledValue() {
    if ((!this.disabledList || this.disabledList.length <= 0) && this.selectorService.getDisabledValue(this.name)) {
      this.disabledList = this.selectorService.getDisabledValue(this.name);
    }
  }
  show() {
    this.isshow = !this.isshow;
    this.cd.markForCheck();
  }
  focusFunction() {
    if (this.group?.controls[this.name]?.disabled) {
      this.isshow = false;
      this.isfocus = false;
    } else {
      this.isshow = true;
      this.isfocus = true;
    }
    this.cd.markForCheck();
  }
  focusOutFunction() {
    if (this.name) {
      const el = document.getElementById(this.name).innerText;
      if (isNullOrUndefined(el) || el === "") {
        this.isfocus = false;
        this.isshow = false;
      }
    }
  }
  testHasValue() {
    if (this.name && this.group?.controls) {
      if (
        this.group?.controls[this.name]?.value !== "" &&
        this.group?.controls[this.name]?.value !== undefined &&
        this.group?.controls[this.name]?.value !== null
      ) {
        if (this.multiple && this.group?.controls[this.name]?.value.length === 0) this.isshow = false;
        else this.isshow = true;
      } else if (!this.isfocus) this.isshow = false;
    }
    this.cd.markForCheck();
    this.cd.detectChanges();
  }

  setItems() {
    if (this.parentIdName) this.paretnIdValue = this._paretnIdValue;
    this._filterdItems = this.dataList;
    if (this.dataList && this.dataList?.length > 0) this._filterdItems = this.dataList;
    if (this.dataList && this.dataList?.length > 0 && (!this._filterdItems || this._filterdItems?.length <= 0)) {
      this._filterdItems = this.dataList.filter((x) => !this.filterKey || x[this.filterKey] != this.filterValue);
    }
    if (this.selectorService.getDataList(this.name) && this.selectorService.getDataList(this.name).length > 0)
      this._filterdItems = this.selectorService.getDataList(this.name);

    if (this._filterdItems && this._filterdItems?.length > 0 && this._filterdItems[0]["Code"])
      this._filterdItems = this._filterdItems.sort((a, b) => a["Code"] - b["Code"]);
    else this._filterdItems = this._filterdItems;
    if (this._filterdItems && this._filterdItems?.length > 0 && this.disabledList && this.disabledList.length > 0) {
      this.disabledList.forEach((ele) => {
        const find = this._filterdItems.find((f) => f.Id === ele);
        if (find) {
          find.disabled = true;
        }
      });
    }
    if (this.multiple && this.hasCheckBox) this.closeOnSelect = false;
    this.cd.markForCheck();
  }

  setDefault() {
    if (
      this.group?.controls &&
      this.name &&
      this.group?.controls[this.name] &&
      (this.hasDefault || this.hasDefault === undefined) &&
      (this.selectorService.getHasDefaultValue(this.name) === undefined || this.selectorService.getHasDefaultValue(this.name)) &&
      !this.group?.controls[this.name]?.value &&
      this.dataList &&
      this.dataList?.length === 1
    ) {
      this.group?.controls[this.name].setValue(this.dataList[0][this.valueFieldName]);
      this.valueChange.emit(this.dataList[0]);
      this.valueChangeByApiName.emit({ data: this.dataList[0], apiName: this.apiName, KeyName: this.name });
    }
  }

  public seletedtvalue: any = {};
  onChange(value: any) {
    this.valueChange.emit(value);
    this.valueChangeByApiName.emit({ data: value, apiName: this.apiName, KeyName: this.name });
    this.cd.markForCheck();
  }
  onClear(value: any) {
    if (this.isMultiColumns) {
      this.setValue("PaginationNumber", 1);
      this.MultiColumnsFilter = "";
      this.paginationData();
    }
    this.valueClear.emit(value);
    this.selectorService.submitted$.next(false);
    this.cd.markForCheck();
  }
  add(value: any) {
    this.addItem.emit(value);
    this.selectorService.submitted$.next(false);
    this.cd.markForCheck();
  }
  remove(value: any) {
    this.removeItem.emit(value);
    this.selectorService.submitted$.next(false);
    this.cd.markForCheck();
  }
  protected getFailedHelper(error: any) {
    console.log(error);
    this.cd.markForCheck();
  }
  async pagination(action: PaginationEnum, filter: string = "") {
    if (!filter) filter = this.MultiColumnsFilter;
    let PaginationNumber = this.formGroup.controls["PaginationNumber"]?.value;
    let skip = this.formGroup.controls["PaginationNumber"]?.value;
    switch (action) {
      case PaginationEnum.next:
        skip = (Number(skip) * 4).toString();
        PaginationNumber = (Number(PaginationNumber) + 1).toString();
        this.setValue("PaginationNumber", PaginationNumber);
        break;
      case PaginationEnum.previous:
        skip = ((Number(skip) - 2) * 4).toString();
        PaginationNumber = (Number(PaginationNumber) - 1).toString();
        this.setValue("PaginationNumber", PaginationNumber);
        break;
      case PaginationEnum.first:
        PaginationNumber = 0;
        skip = 0;
        this.setValue("PaginationNumber", 1);
        break;
      case PaginationEnum.last:
        // PaginationNumber = this.totalPage;
        skip = ((Number(this.totalPage) - 1) * 4).toString();
        this.setValue("PaginationNumber", this.totalPage);
        break;
      case PaginationEnum.custom:
        skip = ((Number(skip) - 1) * 4).toString();
        break;
      default:
        PaginationNumber = 0;
        this.setValue("PaginationNumber", 1);
    }

    if (PaginationNumber > this.totalPage - 1) {
      skip = ((Number(this.totalPage) - 1) * 4).toString();
      this.setValue("PaginationNumber", this.totalPage);
    }
    if (PaginationNumber < 1) {
      PaginationNumber = 1;
      skip = 0;
      this.setValue("PaginationNumber", 1);
    }
    await this._httpCommonService
      .GetPagining<PagingDataResult<any>>(this.apiName, this.filterKey, filter, skip, 4, this.SortColumn, this.IsEqual)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then((x: PagingDataResult<any>) => {
        this.dataList = (x as any)?.Data;
        this.totalPage = Math.trunc(x?.TotalPage / 4) + ((x?.TotalPage / 4) % 1 > 0 ? 1 : 0);
        console.log(x);
        if (!PaginationEnum) {
          this.mainDataList = x;
        }
        this.cd.markForCheck();
      });
  }
  async setValuePagination($event) {
    this.setValue("PaginationNumber", $event.target.value);
    await this.pagination(PaginationEnum.custom);
  }
  search($event) {
    if (this.isMultiColumns) {
      this.MultiColumnsFilter = $event;
      if (this.startSearch) return;
      this.startSearch = true;
      if (this.MultiColumnsFilter) {
        setTimeout(() => {
          this.pagination(null, this.MultiColumnsFilter);
          this.startSearch = false;
        }, 2000);
      } else {
        this.pagination(null, this.MultiColumnsFilter);
        this.startSearch = false;
      }
    }
    this.MultiColumnsFilter = $event;
    console.log("");
  }
  close() {
    this.MultiColumnsFilter = "";
  }
  open() {
    // this.dataList = Object.assign({}, this.mainDataList?.Data);
    // this.totalPage = this.mainDataList?.TotalPage;
    if (this.isMultiColumns) {
      this.formGroup = new FormGroup({
        PaginationNumber: new FormControl(1, [Validators.required, Validators.email]),
      });
      this.MultiColumnsFilter = "";
      this.paginationData();
    }
  }

  private getDataValueWhenValueIsNotExistInDataList(): void {
    if (this.group?.controls[this.name].value && !this.dataList.find((x) => x[this.valueFieldName] === this.group?.controls[this.name].value)) {
      this._httpCommonService
        .GetPagining<PagingDataResult<any>>(this.apiName, this.valueFieldName, this.group?.controls[this.name].value, 0, 0, null, this.IsEqual)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then((x: PagingDataResult<any>) => {
          if (x?.Data?.length) {
            const copyDatalist = Object.assign([], this.dataList);
            this.dataList = [];
            copyDatalist.push(x.Data[0]);
            this.dataList = copyDatalist;
            this.mainDataList?.Data?.push(x.Data[0]);
            this.cd.markForCheck();
            this.cd.detectChanges();
          }
        });
    }
  }
  setValue(key: string, value: any, validator: boolean = false, patternKey: string = undefined) {
    if (!this.formGroup) {
      let group: any = {};
      this.formGroup = new UntypedFormGroup(group);
    }
    if (this.formGroup) {
      if (!this.formGroup.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
      else this.formGroup.controls[key].setValue(value);
      this.formGroup.controls[key].clearValidators();
    }

    if (validator && this.formGroup && this.formGroup.controls[key]) {
      this.formGroup.controls[key].setValidators(Validators.required);
    }
    if (patternKey && this.formGroup) {
      this.formGroup.controls[key].setValidators(Validators.pattern(patternKey));
    }
  }
}
export enum PaginationEnum {
  none = 0,
  next = 1,
  previous = 2,
  last = 3,
  first = 4,
  custom = 5,
}
